import { useInteractionDoneTracking } from "@/mixins/tracking/interaction-done";
import menuCodes from "@/utils/menu-codes";

export const headerMenuLayerProps = () => ({
  zoneMerch: {
    type: String,
    required: false,
    default:
      ''
  },
  brands: {
    type: String,
    required: false,
    default: ""
  },
  category: {
    type: Object,
    required: true
  },
  showLinks: {
    type: Boolean,
    required: false,
    default: false
  },
  coinDesMarquesIds: {
    type: Array,
    required: false,
    default: () => []
  }
})

export const headerMenuLayerEmits = () => ([
  "categoryAccessed"
])

export const useHeaderMenuLayer = (props, context) => {

  const { trackEvent } = useInteractionDoneTracking()

  const categoryRouting = ref([props.category]);
  const previousIndex = ref([]);

  const categoryRef = reactive(props.category);

  const currentCategory = computed(() => {
    return categoryRouting.value.length > 0 ? categoryRouting.value[categoryRouting.value.length - 1] : props.category;
  })
  const parentCategory = computed(() => {
    return categoryRouting.value.length > 1 ? categoryRouting.value[categoryRouting.value.length - 2] : null;
  })
  const isCoinDesMarques = computed(() => {
    return props.coinDesMarquesIds.includes(currentCategory.value.id)
  })

  const reset = () => {
    categoryRouting.value = [props.category];
  }
  const redirectedToProductList = (category) => {
    if (props.isCoinDesMarques) {
      trackEvent({
        categoryGA: trackingCodes.CATEGORYGA.menu,
        actionGA: trackingCodes.ACTIONGA.decouvrezLesMarques,
        labelGA: category.attributes.libelle
      });
    } else {
      const arborescence = [...categoryRouting.value, category];

      trackEvent({
        categoryGA: trackingCodes.CATEGORYGA.menu,
        actionGA: arborescence[0].attributes.libelle,
        labelGA: arborescence[1] ? arborescence[1].attributes.libelle : undefined,
        click_chapter4: arborescence[2] ? arborescence[2].attributes.libelle : undefined,
        click_text: arborescence[3] ? arborescence[3].attributes.libelle : undefined
      });
    }
  }
  const categoryAccessed = () => {
    context.emit("categoryAccessed");
  }
  const getPushData = (category, code) => {
    return category.attributes.push_zones.length > 0 ? category.attributes.push_zones.find(e => e.code === code) !== undefined ? category.attributes.push_zones.find(e => e.code === code) : {} : {}
  }

  watch(
    () => props.category,
    () => {
      reset();
    })

  return {
    categoryRouting,
    previousIndex,
    currentCategory,
    parentCategory,
    isCoinDesMarques,
    categoryRef,
    reset,
    redirectedToProductList,
    categoryAccessed,
    getPushData,
    menuCodes
  }
}